<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div id="createPro" style="width: calc(100% - 150px)">
        <Breadcrumb></Breadcrumb>
        <div style="text-align: right;margin: auto;;padding-top: 10px;">
            <el-button size="small">一键翻译</el-button>
            <el-button size="small" type="primary" @click="saveEdit">保存</el-button>
            <vxe-button status="warning" transfer placement="bottom" size="small" style="margin-left: 10px" @dropdown-click="openShopsCheckModel">
                <template v-slot >保存并认领到</template>
                <template v-slot:dropdowns>
                    <vxe-button type="text" content="亚马逊采集箱" name="04"></vxe-button>
                </template>
            </vxe-button>
        </div>
        <!--        <div style="width: 75%;height: 100px;border-radius: 5px;margin: 10px auto;background-color: #f5e6d1;display: flex;align-items: center;">-->
        <!--            <img src="img/tip.png" style="padding:0 20px;"/>-->
        <!--            <div style="float: right;">-->
        <!--                <span>使用说明</span></br>-->
        <!--                <span>此处是一段说明内容</span>-->
        <!--            </div>-->
        <!--        </div>-->
        <!--        <div style="text-align: right;width: 75%;margin: auto">-->
        <!--            <span style="color:red">*</span><span style="color:#c4c6c8"> 为必填项</span>-->
        <!--        </div>-->
        <div id="main">
            <el-form :model="editForm" ref="editForm" label-width="150px">
                <div id="p1" class="t_plane self_el_item_form">
                    <div class="pl_til">平台定制信息（注：下列信息，仅在此平台定制系统生效）</div>
                    <div class="pl_content">
                        <el-form-item label="来源URL:" id="url_ly">
                            <template v-for="(item,index) in editForm.urls" >
                                <el-input :key="'url_4_' + index" size="small" v-model="item.url" maxlength="400" :disabled="index == 0" style="width:50%;margin:0 5px 5px 0;">
                                    <template slot="prepend" style="width: 20px;">{{index +1}}</template>
                                    <el-button slot="append" @click="goUrl(item)">访问</el-button>
                                </el-input>
                                <a :key="'a_1' +index" class="url_a" @click="addUrl"><i class="el-icon-plus" v-show="index == 0 && urlSize < 5"></i></a>
                                <a :key="'a_2' +index" class="url_a" @click="deleteUrl(index)"><i class="el-icon-minus" v-if="index > 0"></i></a>
                            </template>
                        </el-form-item>

                    </div>
                </div>
                <div class="t_plane self_el_item_form" id="proInfo">
                    <div class="pl_til">产品信息</div>
                    <div class="pl_content">
                        <el-form-item prop="productTitle" label="SKU">
                            <el-input size="small" v-model="editForm.sku" style="width:50%"></el-input>
                        </el-form-item>
                        <el-form-item prop="productTitle_m" label="产品标题">
                            <el-input size="small" v-model="editForm.title" style="width:50%"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="t_plane self_el_item_form">
                    <div class="pl_til">产品图片</div>
                    <div class="pl_content">
                        <el-upload style="padding-left: 100px" multiple :file-list="fileList" action="#" :before-upload="beforeUpload" :http-request="requertUpload" :show-file-list="false">
                            <el-button size="small" type="primary">点击上传</el-button>
                            <div slot="tip" class="el-upload__tip">
                                <div style="display: flex;">
                                    <div style="width:40px;text-align: center;background-color: #009999;margin-right: 10px;color: white"><span>说明</span></div>
                                    <div>
                                        <span>点击图片拖动，即可调整图片顺序!</span>
                                    </div>
                                </div>
                                <draggable :animation='200' :list="editForm.pics" @start="popoverDisabled = true" @end="popoverDisabled = false">
                                    <transition-group style="display: flow-root">
                                        <li class="prop-list"  v-for="(item,index) in editForm.pics" :key="index" >
                                            <el-popover placement="right" :disabled="popoverDisabled" :ref="popoverRef + index" :close-delay="closeDelay" width="300" trigger="hover" :enterable="enterable">
                                                <div style="width: 300px;height: 300px;display: flex;justify-content: center;align-items: center">
                                                    <img class="img-big" :src="item.picUrl" style="width: 300px;height: 300px;object-fit: contain"/>
                                                </div>
                                                <div slot="reference" style="margin: 10px;width: 120px;border: 1px solid #EBEEF5">
                                                    <div style="width: 120px;height: 120px;display: flex;justify-content: center;align-items: center">
<!--                                                        <img class="img-small" :src="item.picUrl" style="width: 120px;height: 120px;object-fit: contain" />-->
                                                        <el-image :src="item.picUrl" style="width: 100%;height: 100%" fit="contain" @load="imgOnload(item)">
                                                            <div slot="placeholder" class="image-slot">
                                                                加载中<span class="dot">...</span>
                                                            </div>
                                                        </el-image>
                                                    </div>
                                                    <div style="text-align: center;font-size: 13px;background-color: #EBEEF5">
                                                        <span v-text="item.width"></span>X<span v-text="item.height"></span>
                                                    </div>
<!--                                                    <div style="display: flex;justify-content: space-between">-->
                                                        <el-button style="padding: 0 !important;float: right" size="mini" class="mini-btn" type="text"
                                                                   @click="removeImg(index)">移除
                                                        </el-button>
<!--                                                    </div>-->
                                                </div>
                                            </el-popover>
                                        </li>
                                    </transition-group>
                                </draggable>
                            </div>
                        </el-upload>
                    </div>
                </div>
                <div class="t_plane">
                    <div class="pl_til">描述信息</div>
                    <div class="pl_content">
                        <el-form-item prop="description">
                            <span style="font-size: 12px">简易描述认领后填充在Wish、亚马逊、Shopee、Joom的产品描述部分，不支持字体、颜色、图片等编辑。</span>
                            <el-input type="textarea" :rows="10" v-model="editForm.simDesc"></el-input>
                        </el-form-item>
                        <el-form-item prop="shotDescription">
                            <span style="font-size: 12px">	详细描述认领后填充在速卖通、eBay、Lazada、Shopify的产品描述部分，一般包含产品功能属性、产品细节图片、售后服务、公司实力等内容。</span>
<!--                            <ckeditor v-model="editForm.detail" :config="editorConfig"></ckeditor>-->
                            <CKEditor4 v-if="ckVisible" v-model="editForm.detail" @getCkEditorInstance="getEditor" :config="editorConfig" @open="openUploadDialog"></CKEditor4>
                        </el-form-item>
                    </div>
                </div>
            </el-form>
        </div>

        <ul id="LoutiNav" style="position: fixed;display: block;">
            <li><span>基本信息</span></li>
            <li><span>产品信息</span></li>
            <li><span>图片信息</span></li>
            <li><span>描述信息</span></li>
        </ul>
        <LocalUpload :ckData="localUploadData"></LocalUpload>
        <OnlineUpload :ckData="onlineUploadData"></OnlineUpload>
        <!--认领弹出框-->
        <el-dialog :close-on-click-modal="false"  
                title="店铺"
                :visible.sync="claimDialogVisible"
                width="50%"
                 class="claim_Title">
            <el-checkbox-group v-model="checkedList" style="display: flex;margin: 15px 20px 7px">
                <el-row v-for="(item,index) in claimList" :key="index" style="margin-left: 15px">
                    <el-checkbox :label="item.shopId">{{item.shopName}}</el-checkbox>
                </el-row>
            </el-checkbox-group>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveAndClaim" size="small">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import draggable from "vuedraggable"
    import {selectById,uploadImg,saveDataCollEdit,getShopByPlatCode,saveAndClaim} from '@/api/product/common'
    import {getImgInfo} from '@/utils/jn'
    import CKEditor4 from '@/components/common/CKEditor'
    import Breadcrumb from '@/components/common/Breadcrumb'
    import LocalUpload from '@/components/common/ckEditorUploadPage/localUpload'
    import OnlineUpload from '@/components/common/ckEditorUploadPage/onlineUpload'
    export default {
        name: "edit",
        components:{draggable,CKEditor4,Breadcrumb,LocalUpload,OnlineUpload},
        data() {
            return {
                ckVisible:false,
                claimDialogVisible:false,
                enterable:false,
                zdList:['印度尼西亚','菲律宾','新加坡','泰国'],
                editForm:{
                    urls:[],
                    sku:null,
                    title:null,//产品标题
                    pics:[],
                    simDesc:null,
                    detail:null,
                },
                urlSize:0,
                isIndeterminate:true,
                checkAll:false,
                otherColor:null,
                otherSize:null,
                treeSelect:{
                    value: 'id',
                    label: 'name',
                    children: 'children',
                },
                editor:null,
                editorConfig:{
                    allowedContent: true,//设置为true，以防止CKEditor 4删除不允许的元素
                    extraPlugins:['uploadImg'],
                    height:'300px',
                    toolbar : [
                        [ 'Source','Maximize'],
                        [ 'Bold', 'Italic', 'Underline', 'Strike'],
                        [ 'TextColor', 'BGColor' ],
                        [  'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock','-','NumberedList', 'BulletedList', '-', 'Outdent', 'Indent',  '-','Subscript', 'Superscript'],
                        [ 'HorizontalRule','RemoveFormat'],
                        ['NewPage', 'Preview', '-', 'Undo', 'Redo' ],
                        '/',
                        [ 'Styles', 'Format', 'Font', 'FontSize' ],
                        [ 'Paste', 'PasteText', 'PasteFromWord','Table'],
                        [ 'Link', 'Unlink','-' ,'uploadImg']
                    ],
                    language: 'zh-cn',
                    wordcount:{
                        showCharCount: true,
                    }

                },
                tempImg: {},
                fileList: [],
                imgList: [],
                popoverDisabled:false,
                closeDelay: 0,
                popoverRef:'popover-',
                localUploadData:{
                    visible:false,
                    editor:null
                },
                onlineUploadData:{
                    visible:false,
                    editor:null
                },
                checkedList:[],//要认领到的店铺
                claimList:[],//平台店铺集合
                takePlat:undefined,//认领平台
            }
        },
        computed:{
            nginx(){
                return this.$store.state.setting.nginx
            },
        },
        created() {
            this.loadData();

        },
        methods: {
            openUploadDialog(val){
                if(val == 'local'){
                    this.localUploadData.visible = true;
                }else if(val == 'online'){
                    this.onlineUploadData.visible = true;
                }
            },
            getEditor(editor){
                this.editor =this.localUploadData.editor = this.onlineUploadData.editor = editor;
            },
            loadData(){
                let collId = this.$route.query.collId;
                selectById(collId).then(res =>{
                    if(res.data.dataUrl != ''){
                        let urls = res.data.dataUrl.split(',');
                        urls.forEach(item => {
                            var cope = {url:item};
                            this.editForm.urls.push(cope);
                        })
                    }
                    this.editForm.sku = res.data.proSku;
                    this.editForm.title = res.data.proTitle;
                    this.editForm.pics = res.data.pics;
                    this.editForm.simDesc = res.data.simDesc.replace(/[;]/g,";\r\n");
                    this.editForm.detail = res.data.detail;
                    this.ckVisible = true;
                }).catch(err =>{})

            },
            imgOnload(item){
                const img = new Image();
                img.src = item.picUrl;
                item.width = img.width;
                item.height = img.height;
            },
            addUrl:function(){
                let cope = {url:''};
                this.editForm.urls.push(cope);
                this.urlSize = this.editForm.urls.length;
            },
            goUrl:function(val){
                window.open(val.url, '_blank').location;
            },
            deleteUrl:function(val){
                this.editForm.urls.splice(val,1);
                this.urlSize = this.editForm.urls.length;
            },
            //锚点
            sideBarTool:function(){
                var aNav = $('#LoutiNav li');
                var aDiv = $('#main .t_plane');
                $(window).scroll(function(){
                    var winH = $(window).height();//可视窗口高度
                    var iTop = $(window).scrollTop();//鼠标滚动的距离
                    aDiv.each(function(){
                        if(winH+iTop - $(this).offset().top>winH - 200){
                            aNav.removeClass('active');
                            aNav.eq($(this).index()).addClass('active');
                        }
                    })
                });
                //点击回到对应面板
                aNav.click(function(){
                    var t = aDiv.eq($(this).index()).offset().top  - 199;
                    $('body,html').animate({"scrollTop":t},500);
                    $(this).addClass('active').siblings().removeClass('active');
                });
            },

            beforeUpload(file) {
            },
            removeImg(index) {
                this.editForm.pics.splice(index,1);
            },
            //覆盖默认上传行为
            requertUpload(data){
                var that = this;
                let formData = new FormData();
                formData.append("imageFile", data.file);
                uploadImg(formData).then(res => {
                    if(res.code == 200){
                        that.msgSuccess("图片上传成功");
                        //此处localhost:8085对应nxinx的ip和监听端口
                        let url = that.nginx+ res.imgUrl;
                        getImgInfo(url).then(res => {
                            that.editForm.pics.push({
                                picId:null,
                                collId:that.$route.query.collId,
                                picUrl:url,
                                width:res.width,
                                height:res.height,
                                sort:null
                            });
                        }).catch(err =>{console.log(err)});


                    }
                }).catch(err => {});
            },
            saveEdit(){
                let params={};
                let urlStr = '';
                this.editForm.urls.forEach((item,index) =>{
                    if(index < this.editForm.urls.length - 1){
                        urlStr += item.url.trim() + ',';
                    }else{
                        urlStr += item.url.trim();
                    }

                });
                params.collId = this.$route.query.collId;
                params.dataUrl = urlStr;
                params.proSku = this.editForm.sku;
                params.proTitle = this.editForm.title;
                params.simDesc = this.editForm.simDesc.replace(/[\r\n]/g,"");
                params.detail = this.editor.getData();
                params.pics = [];
                this.editForm.pics.forEach((item,index) =>{
                    item.sort = index +1;
                    params.pics.push(item);
                })
                saveDataCollEdit(params).then(res => {
                    if(res.code == 200){
                        this.msgSuccess("编辑成功");
                    }
                }).catch(err => {});
            },
            //保存并认领
            openShopsCheckModel(obj){
                this.claimDialogVisible = true;
                this.takePlat = obj.name;
                getShopByPlatCode(obj.name).then(res =>{
                    this.claimList = res.data;
                }).catch(err =>{});

            },
            saveAndClaim(){
                if (this.checkedList.length==0){
                    this.msgError("至少选择一间店铺");
                    return
                }
                let params ={
                    "shopList":this.checkedList,
                    "takePlat":this.takePlat,
                    "collIds":[this.$route.query.collId],
                };
                let urlStr = '';
                this.editForm.urls.forEach((item,index) =>{
                    if(index < this.editForm.urls.length - 1){
                        urlStr += item.url.trim() + ',';
                    }else{
                        urlStr += item.url.trim();
                    }

                });
                params.collId = this.$route.query.collId;
                params.dataUrl = urlStr;
                params.proSku = this.editForm.sku;
                params.proTitle = this.editForm.title;
                params.simDesc = this.editForm.simDesc.replace(/[\r\n]/g,"");
                params.detail = this.editor.getData()
                params.pics = [];
                this.editForm.pics.forEach((item,index) =>{
                    item.sort = index +1;
                    params.pics.push(item);
                })
                saveAndClaim(params).then(res =>{
                    if(res.code == 200){
                        this.$message.success("操作成功，请到对应平台采集箱查看");
                    }
                    this.claimDialogVisible = false;
                }).catch(err =>{
                    this.claimDialogVisible = false;
                });
            },

        },
        mounted() {
            this.sideBarTool();
        }
    }
</script>

<style>
    #url_ly .el-input-group__append,#url_ly .el-input-group__prepend{padding: 0 10px !important;color: #000000;}
    #url_ly .el-input-group__append:hover{color: #4934b2;}
    .url_a{
        color:#4934b2;
        cursor: pointer;
        font-size: 18px;
    }
    .prop-list{float: left}
    i{font-style: normal;}
    ul,li,dl,ol{list-style: none;}
    #LoutiNav{position: fixed; top: 250px; right: 50px; display: none;}
    #LoutiNav li{ width: 80px; height: 30px; line-height: 30px; text-align: left; cursor: pointer;}
    #LoutiNav .active{ color: red;}
    #goTop{width: 40px;height: 40px; line-height: 40px;text-align: center; background: gray; position: fixed;bottom: 30px; right: 30px; cursor: pointer;border-radius: 5px; display: none; }
    .t_plane{ border-radius: 5px;margin: 10px auto;background-color: #ffffff;}
    #erweima{width: 130px; height: 130px; background: palegreen; display: none; position: absolute; right: 46px; bottom: 5px;line-height: 130px; text-align: center; font-size: 20px; border-radius:10px ;}

  
    .self_el_item_form .el-form-item{
        margin-bottom:17px !important;
    }
    .item_bot{display: flex;}
    .item_bot span,.item_bot > .el-checkbox__label{font-size: 12px !important;}
    #proInfo .el-collapse-item__header{
        height: 32px !important;
        border: 0px solid #EBEEF5 !important;
        border-radius: 5px;
    }
    .el-collapse-item:last-child{
        border: 1px solid #ccc;
        border-radius: 5px;
    }
    .span_4{float: right;}
    .use-width{width: calc(100% - 6px) !important;height: initial !important;}
    .use-height{width: initial !important;height: calc(100% - 6px) !important;}
</style>
